import React, { useEffect } from 'react'
import indietro from '../icons/indietro.png'
import { Link } from 'react-router-dom'

const Trading = () => {
    useEffect(() => {
        // Forza il ricaricamento delle immagini widget
        const widgets = document.querySelectorAll('.widget');
        widgets.forEach(widget => {
            const originalSrc = widget.getAttribute('data-original-src');
            if (originalSrc) {
                widget.src = `${originalSrc}&_=${new Date().getTime()}`;
            }
        });
    }, []);

    return (
        <>
            <Link to="/home">
                <img src={indietro} className="close" alt="" />
            </Link>
            <section>
                <div className="title52 topBottom30">Le mie strategie</div>
                <div className="around-row bottom50">
                    {/* <div>
                        <p className="text-center title24">The king 2.0</p>
                        <a href="https://www.myfxbook.com/members/cerios" target="_blank" rel="noopener noreferrer">
                            <img 
                                alt="widget" 
                                className="widget" 
                                src="https://widget.myfxbook.com/widget/widget.png?accountOid=11300608&type=6" 
                                data-original-src="https://widget.myfxbook.com/widget/widget.png?accountOid=11300608&type=6"
                            />
                        </a>
                    </div>
                    <div>
                        <p className="text-center title24">Vision 3.0 Extreme</p>
                        <a href="https://www.myfxbook.com/members/cerios" target="_blank" rel="noopener noreferrer">
                            <img 
                                alt="widget" 
                                className="widget" 
                                src="https://widget.myfxbook.com/widget/widget.png?accountOid=11599650&type=6"
                                data-original-src="https://widget.myfxbook.com/widget/widget.png?accountOid=11599650&type=6"
                            />
                        </a>
                    </div> */}
                    <div>
                        <p className="text-center title24">Vision Radar HR</p>
                <a href="https://www.myfxbook.com/members/cerios/vision-radar-hr/11740106"><img alt="widget" src="https://widget.mfbcdn.net/widget/widget.png?accountOid=11740106&type=6"/></a>

                    </div>
                </div>
                <div className="text-center mobile topBottom30">
                    <div className="bottom20"><strong>Disclaimer</strong></div>
                    Il presente sito ha esclusivamente finalità didattiche. Non deve pertanto essere inteso in alcun modo come consiglio operativo di investimento né come sollecitazione alla raccolta di pubblico risparmio. I risultati presentati – reali o simulati – non costituiscono alcuna garanzia relativamente a ipotetiche performance future. L'attività speculativa comporta notevoli rischi economici e chiunque la svolga lo fa sotto la propria ed esclusiva responsabilità.
                </div>
            </section>
        </>
    )
}

export default Trading